import React, { useEffect, useState } from "react";
import Parse from "parse";
import { appInfo } from "../constant/appinfo";
import { NavLink, useNavigate } from "react-router";
import {
  getAppLogo,
  openInNewTab,
  saveLanguageInLocal,
  usertimezone
} from "../constant/Utils";
import { useDispatch } from "react-redux";
import Title from "../components/Title";
import { emailRegex } from "../constant/const";
import { useLocation } from "react-router-dom";
import Loader from "../primitives/Loader";
import Alert from "../primitives/Alert";
import { showTenant } from "../redux/reducers/ShowTenant";
import { useTranslation } from "react-i18next";
import jwtDecode from "jwt-decode";
import createKeycloakInstance from "../keycloak";

const LoginSSO = () => {
  const appName = "LeadnestSign™";
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  // State variables
  const [showPassword, setShowPassword] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [lengthValid, setLengthValid] = useState(false);
  const [caseDigitValid, setCaseDigitValid] = useState(false);
  const [specialCharValid, setSpecialCharValid] = useState(false);
  const [isAuthorize, setIsAuthorize] = useState(false);
  const [isSubscribeNews, setIsSubscribeNews] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [loading, setLoading] = useState(true);
  const [isModal, setIsModal] = useState(false);
  const [image, setImage] = useState();

  const [state, setState] = useState({
    loading: false,
    alertType: "success",
    alertMsg: "",
    email: "",
    password: ""
  });

  const [status, setStatus] = useState({
    loading: true,
    error: "",
    message: t("authenticating")
  });

  const [token, setToken] = useState(null);
  const [keycloak, setKeycloak] = useState(null);
  const [jwtToken, setJwtToken] = useState(null);
  const [decodedToken, setDecodedToken] = useState(null);

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  useEffect(() => {
    authenticate();
  }, []);

  // Handle form input changes
  const handleChange = (event) => {
    let { name, value } = event.target;
    if (name === "email") {
      value = value?.toLowerCase()?.replace(/\s/g, "");
    }
    setState({ ...state, [name]: value });
  };

  // Show toast notifications
  const showToast = (type, msg) => {
    setState({ ...state, loading: false, alertType: type, alertMsg: msg });
    setTimeout(() => setState({ ...state, alertMsg: "" }), 2000);
  };

  // Logout user function
  const logOutUser = async () => {
    setIsModal(false);
    try {
      await Parse.User.logOut();
    } catch (err) {
      console.log("Err while logging out", err);
    }
    let appdata = localStorage.getItem("userSettings");
    let applogo = localStorage.getItem("appLogo");
    let defaultmenuid = localStorage.getItem("defaultmenuid");
    let PageLanding = localStorage.getItem("PageLanding");
    let baseUrl = localStorage.getItem("baseUrl");
    let appid = localStorage.getItem("parseAppId");

    localStorage.clear();
    saveLanguageInLocal(i18n);

    localStorage.setItem("appLogo", applogo);
    localStorage.setItem("defaultmenuid", defaultmenuid);
    localStorage.setItem("PageLanding", PageLanding);
    localStorage.setItem("userSettings", appdata);
    localStorage.setItem("baseUrl", baseUrl);
    localStorage.setItem("parseAppId", appid);
  };

  // Keycloak authentication
  const authenticate = async () => {
    const keycloak = createKeycloakInstance();
    try {
      const authenticated = await keycloak.init({
        onLoad: "login-required",
        checkLoginIframe: false
      });

      if (authenticated) {
        const token = keycloak.token;
        const decoded = jwtDecode(token);
        setToken(token);
        setDecodedToken(decoded);
        setKeycloak(keycloak);
        console.log("Keycloak token:", token);
        console.log("Decoded token:", decoded);

        // Process SSO login with decoded token
        await handleSSOSubmit(decoded);
      } else {
        console.error("Keycloak authentication failed.");
        setStatus({
          loading: false,
          error: "Authentication failed",
          message: "Failed to authenticate with Keycloak"
        });
      }
    } catch (err) {
      console.error("Authentication error:", err);
      setStatus({
        loading: false,
        error: err.message,
        message: "Authentication error occurred"
      });
    }
  };

  // Handle SSO submission with decoded token (replaces form event)
  // const handleSSOSubmit = async (decodedToken) => {
  //     console.log("handleSSOSubmit", decodedToken);
  //      clearStorage();

  //     // Validate token
  //     if (!decodedToken || !decodedToken.email) {
  //         showToast("danger", "Invalid SSO token - missing email");
  //         setStatus({ loading: false, error: "Invalid token", message: "Token validation failed" });
  //         return;
  //     }

  //     // Extract user details from token
  //     const email = decodedToken.email.toLowerCase().replace(/\s/g, "");
  //     const name = decodedToken.name || decodedToken.preferred_username || email;
  //     const password = "12345678"; // Default password for SSO users

  //     console.log("SSO Login attempt:", { email, name });

  //     // Clear previous session data
  //     localStorage.removeItem("accesstoken");
  //     localStorage.setItem("appLogo", appInfo.applogo);

  //     setState({ ...state, loading: true });
  //     setStatus({ loading: true, error: "", message: "Processing login..." });

  //     try {
  //         // First attempt: Try to login with existing user
  //         console.log("Attempting login with existing user:", email);
  //         const user = await Parse.User.logIn(email, password);
  //         console.log("Login successful for existing user:", user);

  //         // Process successful login using the same flow as normal login
  //         await processUserLogin(user, email);

  //     } catch (loginError) {
  //         console.log("Initial login failed:", loginError);

  //         // Handle user not found error (code 101)
  //         if (loginError.code === 101) {
  //             console.log("User not found, creating new user...");

  //             try {
  //                 // Create new user for SSO
  //                 const newUser = new Parse.User();
  //                 newUser.set("username", email);
  //                 newUser.set("email", email);
  //                 newUser.set("password", password);
  //                 newUser.set("name", name);
  //                 newUser.set("phone", "8888888888"); // Default phone for SSO users

  //                 console.log("Creating new user:", { email, name });
  //                 await newUser.save();
  //                 console.log("New user created successfully");

  //                 // Login the newly created user
  //                 const loginUser = await Parse.User.logIn(email, password);
  //                 console.log("Login successful for new user:", loginUser);

  //                 // Process successful login
  //                 await processUserLogin(loginUser, email);

  //             } catch (signupError) {
  //                 console.log("Signup error:", signupError);

  //                 // Handle race condition - user might have been created by another process
  //                 if (signupError.code === 202) {
  //                     console.log("User already exists, retrying login...");
  //                     try {
  //                         const retryUser = await Parse.User.logIn(email, password);
  //                         await processUserLogin(retryUser, email);
  //                     } catch (retryError) {
  //                         console.error("Retry login failed:", retryError);
  //                         handleSSOLoginFailure(retryError, email);
  //                     }
  //                 } else {
  //                     console.error("User creation failed:", signupError);
  //                     showToast("danger", signupError.message || "Failed to create user account");
  //                     setState({ ...state, loading: false });
  //                     setStatus({ loading: false, error: signupError.message, message: "User creation failed" });
  //                 }
  //             }
  //         } else {
  //             // Handle other login errors
  //             console.error("Login error:", loginError);
  //             handleSSOLoginFailure(loginError, email);
  //         }
  //     }
  // };

  const handleSSOSubmit = async (decodedToken) => {
    console.log("handleSSOSubmit", decodedToken);

    clearStorage();

    // Validate token
    if (!decodedToken || !decodedToken.email) {
      showToast("danger", "Invalid SSO token - missing email");
      setStatus({
        loading: false,
        error: "Invalid token",
        message: "Token validation failed"
      });
      return;
    }

    // Extract and sanitize user details
    const email = decodedToken.email.toLowerCase().replace(/\s/g, "");
    const name = decodedToken.name || decodedToken.preferred_username || email;
    const password = "12345678"; // Default password for SSO users

    console.log("SSO Login attempt:", { email, name });

    localStorage.removeItem("accesstoken");
    localStorage.setItem("appLogo", appInfo.applogo);

    setState({ ...state, loading: true });
    setStatus({ loading: true, error: "", message: "Processing login..." });

    try {
      // Attempt login with existing Parse user
      console.log("Attempting login with existing user:", email);
      const user = await Parse.User.logIn(email, password);
      console.log("Login successful for existing user-----1:", user);

      // Ensure extended user exists
      await ensureExtendedUser(email, name);
      console.log("Login successful for existing user----2:", user);

      // Proceed with Parse-based session navigation
      await handleNavigation(user.getSessionToken());
      console.log("Login successful for existing user------3:", user);
    } catch (loginError) {
      console.log("Initial login failed:", loginError);

      // User not found, create new user
      if (loginError.code === 101) {
        console.log("User not found, creating new user...");

        try {
          const newUser = new Parse.User();
          newUser.set("username", email);
          newUser.set("email", email);
          newUser.set("password", password);
          newUser.set("name", name);
          newUser.set("phone", "8888888888");

          await newUser.save();
          console.log("New user created successfully");

          // Login after creation
          const loginUser = await Parse.User.logIn(email, password);

          // Create extended user
          await ensureExtendedUser(email, name);

          // Navigate
          await handleNavigation(loginUser.getSessionToken());
        } catch (signupError) {
          console.error("Signup error:", signupError);

          // Handle race condition
          if (signupError.code === 202) {
            console.log("User already exists, retrying login...");
            try {
              const retryUser = await Parse.User.logIn(email, password);
              await ensureExtendedUser(email, name);
              await handleNavigation(retryUser.getSessionToken());
            } catch (retryError) {
              console.error("Retry login failed:", retryError);
              handleSSOLoginFailure(retryError, email);
            }
          } else {
            showToast(
              "danger",
              signupError.message || "Failed to create user account"
            );
            setState({ ...state, loading: false });
            setStatus({
              loading: false,
              error: signupError.message,
              message: "User creation failed"
            });
          }
        }
      } else {
        // Other login errors
        console.error("Login error:", loginError);
        handleSSOLoginFailure(loginError, email);
      }
    }
  };
  const ensureExtendedUser = async (email, name) => {
    console.log("Ensuring extended user for:", email);
    try {
      console.log("Ensuring extended user for---1:", email);
      const result = await Parse.Cloud.run("getUserDetails");
      if (!result) {
        console.log("Extended user not found, creating...");

        const params = {
          userDetails: {
            jobTitle: "null",
            company: "null",
            name: name,
            email: email,
            phone: "8888888888",
            role: "contracts_Admin",
            timezone:
              Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata"
          }
        };

        await Parse.Cloud.run("addadmin", params);
        console.log("Extended user created successfully");
      } else {
        console.log("Extended user already exists");
      }
    } catch (err) {
      console.error("Error in ensureExtendedUser", err);
      throw err;
    }
  };

  // Process user login - EXACT SAME FLOW AS NORMAL LOGIN
  const processUserLogin = async (user, email) => {
    console.log("Processing user login for:", email);

    try {
      let _user = user.toJSON();
      console.log("User data:", _user);

      // Store basic user information
      localStorage.setItem("UserInformation", JSON.stringify(_user));
      localStorage.setItem("userEmail", email);
      localStorage.setItem("accesstoken", _user.sessionToken);
      localStorage.setItem("scriptId", true);

      if (_user.ProfilePic) {
        localStorage.setItem("profileImg", _user.ProfilePic);
      } else {
        localStorage.setItem("profileImg", "");
      }

      // Check extended class user role and tenantId - SAME AS NORMAL LOGIN
      try {
        const userSettings = appInfo.settings;
        const extUser = await Parse.Cloud.run("getUserDetails");
        console.log("Extended user details:", extUser);
        if (extUser) {
          console.log("Extended user details:", extUser);

          const IsDisabled = extUser?.get("IsDisabled") || false;
          if (!IsDisabled) {
            const userRole = extUser?.get("UserRole");
            const menu =
              userRole && userSettings.find((menu) => menu.role === userRole);

            if (menu) {
              const _currentRole = userRole;
              const redirectUrl =
                location?.state?.from || `/${menu.pageType}/${menu.pageId}`;
              let _role = _currentRole.replace("contracts_", "");
              localStorage.setItem("_user_role", _role);

              // Handle language preference
              const checkLanguage = extUser?.get("Language");
              if (checkLanguage) {
                i18n.changeLanguage(checkLanguage);
              }

              // Store extended user information
              const results = [extUser];
              const extUser_str = JSON.stringify(results);
              localStorage.setItem("Extand_Class", extUser_str);

              const extInfo = JSON.parse(JSON.stringify(extUser));
              localStorage.setItem("userEmail", extInfo.Email);
              localStorage.setItem("username", extInfo.Name);

              // Handle tenant information
              if (extInfo?.TenantId) {
                const tenant = {
                  Id: extInfo?.TenantId?.objectId || "",
                  Name: extInfo?.TenantId?.TenantName || ""
                };
                localStorage.setItem("TenantId", tenant?.Id);
                dispatch(showTenant(tenant?.Name));
                localStorage.setItem("TenantName", tenant?.Name);
              }

              // Store menu and page information
              localStorage.setItem("PageLanding", menu.pageId);
              localStorage.setItem("defaultmenuid", menu.menuId);
              localStorage.setItem("pageType", menu.pageType);

              // Update state and navigate
              setState({ ...state, loading: false });
              setStatus({
                loading: false,
                error: "",
                message: "Login successful"
              });

              console.log("Redirecting to:", redirectUrl);
              navigate(redirectUrl);
            } else {
              console.log("No menu found for user role, showing modal");
              setState({ ...state, loading: false });
              setIsModal(true);
              setStatus({
                loading: false,
                error: "Role configuration missing",
                message: "User role not properly configured"
              });
            }
          } else {
            console.log("User account is disabled");
            showToast("danger", t("do-not-access-contact-admin"));
            setStatus({
              loading: false,
              error: "Account disabled",
              message: "Your account has been disabled"
            });
            await logOutUser();
          }
        } else {
          console.log("Extended user not found");
          showToast("danger", t("user-not-found"));
          setStatus({
            loading: false,
            error: "User not found",
            message: "Extended user profile not found"
          });
          await logOutUser();
        }
      } catch (error) {
        console.error("Error while fetching user details", error);
        showToast("danger", t("something-went-wrong-mssg"));
        setStatus({
          loading: false,
          error: error.message,
          message: "Failed to fetch user details"
        });
      }
    } catch (error) {
      console.error("Error in processUserLogin:", error);
      showToast("danger", `${error.message}`);
      setStatus({
        loading: false,
        error: error.message,
        message: "Login processing failed"
      });
    }
  };

  // Handle SSO login failures
  const handleSSOLoginFailure = (error, email) => {
    console.error("SSO login failed", error);

    let errorMessage = "SSO login failed";

    if (error.code === 101) {
      errorMessage = "Invalid username/password or user not found";
      try {
        // Offer password reset for SSO users
        Parse.User.requestPasswordReset(email);
        showToast(
          "info",
          t("verification-code-sent") || "Password reset email sent."
        );
      } catch (resetError) {
        console.error("Password reset failed", resetError);
        showToast("danger", "Failed to send password reset email.");
      }
    } else {
      errorMessage = error.message || "Authentication failed";
    }

    showToast("danger", errorMessage);
    setState({ ...state, loading: false });
    setStatus({
      loading: false,
      error: errorMessage,
      message: "Login failed"
    });
  };

  // // Verify token with backend (if needed)
  // const verifyTokenWithBackend = async (token) => {
  //     try {
  //         const response = await fetch(
  //             "http://localhost:8080/api/auth/verify-keycloak",
  //             {
  //                 method: "POST",
  //                 headers: {
  //                     "Content-Type": "application/json",
  //                     Authorization: `Bearer ${token}`
  //                 }
  //             }
  //         );

  //         if (!response.ok) {
  //             const errorText = await response.text();
  //             throw new Error(errorText);
  //         }

  //         const result = await response.json();
  //         console.log("✅ Backend response:", result);
  //         return result;
  //     } catch (err) {
  //         console.error("Backend verification error:", err);
  //         throw new Error(t("backend-connection-failed"));
  //     }
  // };

  // Handle admin setup
  const handleAdminSetup = async (
    name,
    email,
    phone,
    jobTitle,
    company,
    usertimezone
  ) => {
    try {
      console.log("Setting up admin privileges...");

      const params = {
        userDetails: {
          jobTitle: jobTitle || "null",
          company: company || "null",
          name: name,
          email: email,
          phone: phone || "8888888888",
          role: "contracts_Admin",
          timezone: usertimezone
        }
      };

      console.log("Admin setup params:", params);
      const usersignup = await Parse.Cloud.run("addadmin", params);
      console.log("Admin setup completed:", usersignup);

      setState({ loading: false });
    } catch (error) {
      console.log("Admin setup error:", error);
      alert(error.message);
      setState({ loading: false });
    }
  };

  // Handle user redirect
  const handleUserRedirect = async () => {
    try {
      const extUser = await Parse.Cloud.run("getUserDetails");

      if (!extUser) throw new Error(t("user-not-found"));
      if (extUser.get("IsDisabled")) throw new Error(t("account-disabled"));

      const userRole = extUser.get("UserRole");
      const menu = appInfo.settings.find((m) => m.role === userRole);

      if (!menu) throw new Error(t("role-config-missing"));

      // Store user information
      localStorage.setItem(
        "accesstoken",
        Parse.User.current()?.getSessionToken()
      );
      localStorage.setItem("userEmail", extUser.get("Email"));

      // Handle tenant information
      const tenantId = extUser.get("TenantId");
      if (tenantId) {
        const tenantName = tenantId.get("TenantName");
        localStorage.setItem("TenantName", tenantName);
        dispatch(showTenant(tenantName));
      }

      // Redirect to appropriate page
      const redirectUrl =
        location?.state?.from || `/${menu.pageType}/${menu.pageId}`;
      navigate(redirectUrl);
    } catch (err) {
      console.error("Redirection error:", err);
      setStatus({ loading: false, error: err.message });
      await logout();
    }
  };

  // Logout function
  const logout = async () => {
    try {
      await Parse.User.logOut();
      if (keycloak) {
        await keycloak.logout();
      }
      localStorage.removeItem("accesstoken");
    } catch (err) {
      console.error("Logout error:", err);
    }
  };

  // Check if user exists
  const checkUserExist = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    try {
      const app = await getAppLogo();
      if (app?.error === "invalid_json") {
        setErrMsg(t("server-down", { appName: appName }));
      } else if (app?.user === "exist") {
        setErrMsg(t("admin-exists"));
      }
    } catch (err) {
      setErrMsg(t("something-went-wrong-mssg"));
      console.log("err in check user exist", err);
    } finally {
      setState((prev) => ({ ...prev, loading: false }));
    }
  };

  // Clear storage
  const clearStorage = async () => {
    try {
      await Parse.User.logOut();
    } catch (err) {
      console.log("Err while logging out", err);
    }
    const baseUrl = localStorage.getItem("baseUrl");
    const appid = localStorage.getItem("parseAppId");
    const applogo = localStorage.getItem("appLogo");
    const defaultmenuid = localStorage.getItem("defaultmenuid");
    const PageLanding = localStorage.getItem("PageLanding");
    const userSettings = localStorage.getItem("userSettings");

    localStorage.clear();
    saveLanguageInLocal(i18n);
    localStorage.setItem("baseUrl", baseUrl);
    localStorage.setItem("parseAppId", appid);
    localStorage.setItem("appLogo", applogo);
    localStorage.setItem("defaultmenuid", defaultmenuid);
    localStorage.setItem("PageLanding", PageLanding);
    localStorage.setItem("userSettings", userSettings);
    localStorage.setItem("baseUrl", baseUrl);
    localStorage.setItem("parseAppId", appid);
  };

  // Handle navigation
  const handleNavigation = async (sessionToken) => {
    console.log("Handling navigation with session token:", sessionToken);
    const res = await Parse.User.become(sessionToken);
    console.log("Handling res---1", res);
    console.log("Handling res---2", res);
    if (res) {
      console.log("Handling res---3", res);
      const _user = JSON.parse(JSON.stringify(res));
      localStorage.setItem("accesstoken", sessionToken);
      localStorage.setItem("UserInformation", JSON.stringify(_user));
      localStorage.setItem("accesstoken", _user.sessionToken);
      localStorage.setItem("scriptId", true);
      if (_user.ProfilePic) {
        localStorage.setItem("profileImg", _user.ProfilePic);
      } else {
        localStorage.setItem("profileImg", "");
      }

      // Check extended class user role and tenentId
      try {
        console.log(
          "**********Fetching user settings and extended user details...*****"
        );
        const userSettings = appInfo.settings;
        const extUser = await Parse.Cloud.run("getUserDetails");
        if (extUser) {
          console.log("Extended user details=========:", extUser);
          const IsDisabled = extUser?.get("IsDisabled") || false;
          if (!IsDisabled) {
            const userRole = extUser?.get("UserRole");
            const menu =
              userRole && userSettings.find((menu) => menu.role === userRole);
            if (menu) {
              const _currentRole = userRole;
              const _role = _currentRole.replace("contracts_", "");
              localStorage.setItem("_user_role", _role);
              const extInfo_stringify = JSON.stringify([extUser]);
              localStorage.setItem("Extand_Class", extInfo_stringify);
              const extInfo = JSON.parse(JSON.stringify(extUser));
              localStorage.setItem("userEmail", extInfo?.Email);
              localStorage.setItem("username", extInfo?.Name);
              if (extInfo?.TenantId) {
                const tenant = {
                  Id: extInfo?.TenantId?.objectId || "",
                  Name: extInfo?.TenantId?.TenantName || ""
                };
                localStorage.setItem("TenantId", tenant?.Id);
                dispatch(showTenant(tenant?.Name));
                localStorage.setItem("TenantName", tenant?.Name);
              }
              localStorage.setItem("PageLanding", menu.pageId);
              localStorage.setItem("defaultmenuid", menu.menuId);
              localStorage.setItem("pageType", menu.pageType);
              setState({
                loading: false,
                alertType: "success",
                alertMsg: t("registered-user-successfully")
              });
              navigate(`/${menu.pageType}/${menu.pageId}`);
            } else {
              setState({
                loading: false,
                alertType: "danger",
                alertMsg: t("role-not-found")
              });
            }
          } else {
            setState({
              loading: false,
              alertType: "danger",
              alertMsg: t("do-not-access")
            });
          }
        }
      } catch (error) {
        console.log("error in fetch extuser", error);
        const msg = error.message || t("something-went-wrong-mssg");
        setState({ loading: false, alertType: "danger", alertMsg: msg });
      } finally {
        setTimeout(() => setState({ loading: false, alertMsg: "" }), 2000);
      }
    }
  };

  // Subscribe to newsletter
  const subscribeNewsletter = async () => {
    try {
      const params = { name: name, email: email, domain: window.location.host };
      await Parse.Cloud.run("newsletter", params);
    } catch (err) {
      console.log("err in subscribeNewsletter", err);
    }
  };

  // Render loading state
  if (status.loading) {
    return (
      <div className="loading-container">
        <Loader />
        <p>{status.message}</p>
      </div>
    );
  }

  // Render error state
  if (status.error) {
    return (
      <div className="error-container">
        <Alert type="danger" message={status.error} />
        <button onClick={() => window.location.reload()}>
          {t("retry") || "Retry"}
        </button>
      </div>
    );
  }

  // Main render - you can add your JSX here for the login form if needed
  return (
    <div className="login-sso-container">
      <Title title="SSO Login" />
      {state.alertMsg && (
        <Alert type={state.alertType} message={state.alertMsg} />
      )}
      {state.loading && <Loader />}
      {isModal && (
        <div className="modal">
          <p>{t("setup-required") || "Additional setup required"}</p>
          <button onClick={() => setIsModal(false)}>
            {t("close") || "Close"}
          </button>
        </div>
      )}
    </div>
  );
};

export default LoginSSO;
